import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import { Label } from "react-bootstrap";
import ChangePassword from "../../changepassword";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import PasswordDrawer from "./passwordDrawer";
import { TrainRounded } from "@material-ui/icons";


const styles = (theme) => ({
  root: {
    // height:'auto',
    margin: 0,
    padding: theme.spacing(2),
    color: "#1f1f1f",
  },
  closeButton: {
    height: "15px",
    width: "15px",
    position: "absolute",
    right: "9px",
    top: "8px",
    color: "white",
    backgroundColor: "#FF0027",
    "&:hover, &.Mui-focusVisible": {
      color: "none",
      backgroundColor: "#FF0027",
    },
  },
  topScrollPaper: {
    margin: "70px",
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
});
const useStyles = makeStyles((theme) => ({
  Change: {
    color: "#001441",
  },
  topScrollPaper: {
    // margin:"35px",
    alignItems: "flex-start",
  },
  topPaperScrollBody: {
    verticalAlign: "top",
  },
}));

const TabView = styled.div`
  @media (min-width: 0px) and (max-width: 767px) {
    display: none;
  }
  @media (min-width: 767px) and (max-width: 1024px) {
    display: visible;
    padding: 20px 20px 0px 20px;
  }
  @media (min-width: 1025px) {
    display: none;
  }
`;

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    "@media (min-width:1025px)":{
    width: "402px",
    height: "auto",
    // display: "flex",
    // justifyContent: "center",
    }
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function CustomizedDialogs() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // const onClose = () => {
  //   window.close();
  // };

  return (
    <div>
      <MenuItem onClick={handleClickOpen} className={classes.Change}>
        Change Password
      </MenuItem>

      <Dialog
        fullScreen={fullScreen}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        classes={{
          scrollPaper: classes.topScrollPaper,
          paperScrollBody: classes.topPaperScrollBody,
        }}
      >
        {/*<DialogTitle id="customized-dialog-title" onClose={handleClose}>*/}
        {/*  Change Password*/}
        {/*</DialogTitle>*/}

        <TabView>
          <div
            style={{
              height: "35px",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px",
            }}
          >
            <PasswordDrawer />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "2.75rem",
            }}
          >
            <div className="changePass">Change Password </div>
            <div>
              <img
                className="cursor-pointer"
                onClick={handleClose}
                src="/images/redCross.svg"
              />
            </div>
          </div>
        </TabView>

        <DialogContent>
          <ChangePassword onClose={handleClose} />
        </DialogContent>
        {/* <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Save changes
          </Button>
        </DialogActions> */}
      </Dialog>
    </div>
  );
}
